var render = function render(){var _vm=this,_c=_vm._self._c;return (
    _vm.sectionEnabled ||
    (!_vm.sectionEnabled && this.$store.state.loggedIn) ||
    _vm.sectionEnabled == undefined
  )?_c('div',{staticClass:"wrapper",style:({ filter: !_vm.sectionEnabled ? 'opacity(50%)' : '' })},[_c('div',[_vm._t("default")],2),(this.$store.state.loggedIn)?_c('div',{staticClass:"enable-section"},[_c('button',{on:{"click":_vm.updateDisplayStatus}},[_vm._v(" "+_vm._s(_vm.sectionEnabled ? "✔️" : "❌")+" ")])]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }